import moment from 'moment'

// Breadcrumb labels, keyed by route pattern (odd path segments become `*`).
// A string is shown as-is; a function receives { id, ...docData } for the
// segment's document and returns the label. Every reachable screen should have
// an entry here so it appears in the breadcrumbs.
export const labelMap = {
  // Dynamic employer routes (with /employers prefix)
  'employers': 'מעסיקים',
  'employers/*': ({ id, name }) => name ? `${name} (${id})` : `מעסיק ${id}`,
  'employers/*/dashboard': 'דף הבית',
  'employers/*/reports': 'דיווחים',
  'employers/*/attendance-board': 'לוח נוכחות',
  'employers/*/absences': 'היעדרויות מאושרות',
  'employers/*/reports-hub': 'דוחות',
  'employers/*/calculations': 'עובדים',
  'employers/*/anomalies': 'חריגות ובקשות',
  'employers/*/variable-components': 'רכיבי שכר משתנים',
  'employers/*/agreements': 'הסכמים',
  'employers/*/agreements/*': ({ id, name }) => name || `הסכם ${id}`,
  'notifications': 'הודעות',
  'employers/*/calculations/*': ({ firstName, lastName, id }) => `${firstName} ${lastName} (${id})`,
  'employers/*/calculations/*/timesheets': 'שעות עבודה',
  'employers/*/calculations/*/documents': 'מסמכים קבועים',
  'employers/*/calculations/*/timesheets/*/documents': 'מסמכים חודשיים',
  'employers/*/calculations/*/timesheets/*': ({ year, month, dayFirst, dayLast }) => dayFirst && dayLast
    ? `${moment(dayFirst.toDate()).format('DD/MM/yyyy')}-${moment(dayLast.toDate()).format('DD/MM/yyyy')}`
    :`${year}-${month}`,
  // Attendance routes
  'attendance': 'דיווח נוכחות',
  'sick-day': 'דיווח מחלה',
  'vacation': 'בקשת חופשה',
  // Legacy routes (keep for backward compatibility)
  'calculations': 'חישובים',
  'timesheets': 'שעות עבודה',
  'report': 'דו״ח שעות נוספות',
  'report-log': 'פירוט חישובי דו"ח',
  'calculations/*': ({ firstName, lastName, id }) => `${firstName} ${lastName} (${id})`,
  'calculations/*/timesheets/*': ({ year, month, dayFirst, dayLast }) => dayFirst && dayLast
    ? `${moment(dayFirst.toDate()).format('DD/MM/yyyy')}-${moment(dayLast.toDate()).format('DD/MM/yyyy')}`
    :`${year}-${month}`,
  'holidays': 'חגים',
  'holidays/*': ({ name }) => name,
  'years': 'שנה',
  'holidays/*/years/*': ({ id }) => id,
  'cities': 'ערים',
  'cities/*': ({ id }) => id,
  'cities/*/*': ({ id }) => id,
  'daylight-saving': 'שעון קיץ/חורף',
  'permissions': 'הרשאות',
  'permissions/*': ({ id }) => id,
}
